// src/pages/Events.js 
// (Assuming this file contains your Events component)

import React from "react";
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from "../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../CommonComponent/Notification/NotificationBar";
import Footer from "../../CommonComponent/Footer/footer";

// Page Component
import EventsContent from "./PageComponent/EventsContent";

const Events = () => {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Events | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Biz Bash Event Goa View Photos Achievers Mega Event Mumbai View Photos Achievers Mega Event Goa View Photos Achievers Mega Event Lonavala View Photos"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/events/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="events" />
                <meta
                    property="og:description"
                    content="Biz Bash Event Goa View Photos Achievers Mega Event Mumbai View Photos Achievers Mega Event Goa View Photos Achievers Mega Event Lonavala View Photos"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/events/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <Navbar />
            <NotificationBar />
            <EventsContent />
            <Footer />
        </>
    );
}

export default Events;